export const GOOGLE_MAPS_API_KEY =
  process.env.REACT_APP_GOOGLE_MAPS_API_KEY ||
  (typeof window !== 'undefined'
    ? (window as Window & { env?: Record<string, string | undefined> }).env
        ?.REACT_APP_GOOGLE_MAPS_API_KEY
    : '');

export const GOOGLE_MAPS_MAP_ID = '894e3c8bb9118737d1a29cdc';

export const libraries: 'places'[] = ['places'];

export const DEFAULT_CENTER = { lat: 51.5072, lng: -0.1276 };

export const MAP_CONTAINER_STYLE = {
  width: '100%',
  height: '300px',
} as const;

export const SEARCH_BOX_BORDER_RADIUS = '25px';

export const MARKER_SCALED_WIDTH = 30;
export const MARKER_SCALED_HEIGHT = 42;
export const INACTIVE_MARKER_SCALE = 0.86;
export const MARKER_HOVER_PEER_OPACITY = 0.8;

export const FIT_BOUNDS_PADDING = {
  top: 56,
  right: 48,
  bottom: 72,
  left: 48,
} as const;

export const FIT_BOUNDS_MAX_ZOOM = 15;

export const GOOGLE_WALLET_GEOFENCE_RADIUS_M = 100;

/** Invisible polyline stroke (px) — wide target for drag-to-resize Apple radius */
export const APPLE_RADIUS_RESIZE_HIT_STROKE_PX = 20;

/** Ignore mousedown this close to pin (m) when starting a radius drag */
export const APPLE_RADIUS_RESIZE_PIN_EXCLUSION_M = 22;
